import PersonTypeService from "../../Services/PersonType.service";
let cachedCurrentVisibleFeaturesPromise = null;
/**
 * This hook provides a map of person type internal names to features, but only loads it once per application initialization to save
 * on HTTP requests and time.
 */
const getCurrentVisibleFeatures = (personTypeInternalNames) => {
    if (!cachedCurrentVisibleFeaturesPromise) {
        cachedCurrentVisibleFeaturesPromise =
            PersonTypeService.searchPersonType().then(({ data }) => {
                const obj = {};
                for (const key of data) {
                    obj[key.internalName] = key.features;
                }
                return obj;
            });
    }
    return cachedCurrentVisibleFeaturesPromise.then((data) => {
        // @ts-expect-error - TS7034 - Variable 'features' implicitly has type 'any[]' in some locations where its type cannot be determined.
        let features = [];
        personTypeInternalNames.forEach((personTypeInternalName) => {
            if (personTypeInternalName) {
                // @ts-expect-error - TS7005 - Variable 'features' implicitly has an 'any[]' type.
                features = features.concat(data[personTypeInternalName]);
            }
        });
        // @ts-expect-error - TS7005 - Variable 'features' implicitly has an 'any[]' type.
        return features;
    });
};
const useCachedLoadVisibleFeatures = (personTypeInternalNames) => getCurrentVisibleFeatures(personTypeInternalNames);
export default useCachedLoadVisibleFeatures;
